module.exports = __webpack_public_path__ + "static/img/interactive-rotating-interpretive-signs.de17bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/specialty-items/interactive-rotating-interpretive-signs.jpg
// module id = 686
// module chunks = 0